import React from 'react';

import defaultAvatar from '../../../../assets/images/default-avatar.png';
import Expert from '../../../../components/Molecules/Expert';
import { contactForm } from '../../../../config/constants';

const NodeExpertTeaser = ({ entity, className, isCard }) => {

  return (
    <Expert
      className={className}
      name={entity.getIn(['title', 0, 'value'], '')}
      workfield={entity.getIn(['field_function', 0, 'value'], '')}
      avatar={entity.getIn(['field_avatar', 0, 'styles', '1_1'], defaultAvatar)}
      linkedIn={entity.getIn(['field_link_to_page', 0, 'uri'], '/')}
      bio={entity.getIn(['field_meta_description', 0, 'value'], entity.getIn(['field_bio', 0, 'value'], ''))}
      link={entity.getIn(['paths', 'nl'], '/')}
      isSmall
      isCard={isCard}
      contactForm={contactForm}
    />
  );
};

export default NodeExpertTeaser;
